import { Component, OnInit } from '@angular/core';
import { DataStorageService } from './services/data-storage/data-storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private dataStorage:DataStorageService){

  }
  ngOnInit(): void {
    this.dataStorage.fetchBulletin();
  }
  onActivate(event) {
    window.scrollTo(0, 0);
  }
}
